import React, { forwardRef, useState, useEffect, useRef } from "react";
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from "../../utilities/IBuildrProps";
import renderContent from "../../utilities/renderContent";

interface IAccordionFaqItemProps extends IBuildrProps {
    question: string;
    answer: string;
    opened: boolean;
    index: number;
    anchorLink: string;
    hash: string;
}

export default styled(forwardRef((props: IAccordionFaqItemProps, ref: any) => {
    const { cmsId, editorClassObj, className, question, answer, opened, index, anchorLink, hash } = props;

    const [open, setOpen] = useState(opened);
    const [height, setHeight] = useState(0);
    const content = useRef(null);

    const currentHash = `#${anchorLink}`;

    useEffect(() => {
        setOpen(opened);
    }, [opened]);

    useEffect(() => {
        if (hash === currentHash && !open) {
            setOpen(true);
        }
    }, [hash])

    useEffect(() => {
        if (open) {
            setHeight(content.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [open]);

    function toggle () {
        if (anchorLink && hash !== currentHash) {
            history.pushState({}, '', currentHash)
        }
        setOpen(!open);
    }

    return (
        <div ref={ref} data-id={cmsId} className={cx("accordion-item", className, editorClassObj)} id={anchorLink && anchorLink} key={index}>
            <div className="accordion-header d-flex justify-content-between align-items-center" onClick={toggle}>
                <p>{renderContent("AccordionFaqItem", question)}</p>
                <div className="icon-container">
                    {open ? <AiOutlineMinusCircle size={21}/> : <AiOutlinePlusCircle size={21}/>}
                </div>
            </div>
            <div 
                className={cx("accordion-body col-lg-8 offset-lg-2")}
                ref={content}
                style={{ height }}>
                {answer ?
                    <div className="accordion-inner-body">
                        {renderContent("AccordionFaqItem", answer)}
                    </div>
                : null}
            </div>
        </div>
    );
}))`

border-top: 2px solid black;
padding-top: 1.2rem;
padding-bottom: 1.2rem;

.accordion-header {
    cursor: pointer;
    p {
        margin: 0;
        font-weight: 500;
    }
    svg {
        font-size: 1.2rem;
        margin-left: 5px;
    }
}

&:last-child {
    border-bottom: 2px solid black;
}
.accordion-body {
    overflow: hidden;
    transition: height .5s ease;
    padding: 0px;

    .accordion-inner-body {
        padding-top: 2.556rem;
        padding-bottom: 1.78rem;
        p:last-child {
            margin: 0;
        }
    }
}
`;